import GridSection from "@/partials/sections/Section/GridSection";
import Image from "next/image";
import { useRouter } from "next/navigation";
import { FaCheck, FaRegUser } from "react-icons/fa6";

function ModalContent({ item }) {
  const router = useRouter();
  return (
    <div>
      <span className="flex  items-center gap-5">
        <figure className="p-3 border rounded-md border-black mt-2">
          <Image
            src={process.env.NEXT_PUBLIC_SPACES_URL + item?.icon}
            alt=""
            width={30}
            height={30}
            className="object-cover"
          />
        </figure>
        <h1 className=" mt-6 pb-4 font-semibold text-2xl text-[#000]">
          {item.title}
        </h1>
      </span>
      <p
        className="text-secondary font-normal text-base"
        style={{ lineHeight: "150%" }}
      >
        {item.description}
      </p>

      <div className="grid grid-cols-2">
        {item?.benefitsLists.slice(1).map((benefit) => (
          <div key={benefit} className="flex items-center gap-3 mt-6">
            <div className="border pt-1 pb-1 pl-1 pr-1 bg-[#0F62FE] rounded-full">
              <FaCheck className="text-white" />
            </div>
            <p className="text-base font-medium">{benefit}</p>
          </div>
        ))}
      </div>

      <button
        onClick={() => router.push("/member")}
        className="w-full bg-[#020202] text-white py-3 mt-12 rounded-[10px] flex items-center justify-center gap-4 hover:bg-[#0F62FE] transition-all duration-500"
      >
        Become a Member
        <FaRegUser className="text-base" />
      </button>
    </div>
  );
}

export default ModalContent;
